import React, {useEffect} from "react";
import {withRouter} from "react-router-dom";
import ReactGA from "react-ga";
import ScrollToTop from "../ScrollToTop";
import styled from "@emotion/styled";
// import homePageKv from "../../images/homepage/homepage.jpg";
import HomeCase from "./HomeCase";
import HomeStory from "./HomeStory";
import HomeAbout from "./HomeAbout";
import homeBg from "../../images/homepage/homePageBg.jpg";
import Masthead from "../Masthead";

const Group = styled.div`
  width: 100%;
  background-image: url(${homeBg});
  background-size: 360px;
  background-position: -50% -50%;
`;

// const Kv = styled.div`
//   width: 100%;
//   height: 100vh;
//   background-image: url(${homePageKv});
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center;
// `;

const Section = styled.section`
  width: 100%;
  margin: auto;
  padding: 120px 0px;
  /* border-left: 0.25px solid rgba(48, 37, 29, 0.1);
  border-right: 0.25px solid rgba(48, 37, 29, 0.1); */
`;

const HomePage = () => {
  useEffect(() => {
    ReactGA.pageview(`/202012_PRADO/`);
    document.title = "TOYOTA Prado - 最重要的乘客";
  }, []);
  return (
    <>
      <ScrollToTop />
      <Masthead ytId={"WP2Ua70V9qk"}/>
      <Group>
        <Section>
          <HomeCase />
        </Section>
        <Section>
          <HomeStory />
        </Section>
        <Section>
          <HomeAbout />
        </Section>
      </Group>
    </>
  )
};

export default withRouter(HomePage);